import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./styles/globals.css";
import { finishConnectIfAny } from "./lib/connect-popup.ts";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element #root not found in index.html");
}

// A relayed OAuth connect answer is completed first, in this session; the popup then reports and closes.
void finishConnectIfAny().then((wasPopup) => { if (!wasPopup) ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
); });
